import React, { FC } from "react";
import { Form, Checkbox, Select } from "antd";
import { Settings } from "../../data-types";
import styles from "./app-settings.css";

const { ["container"]: containerClassName } = styles as any;

export type AppSettingsProps = {
  settings: Partial<Settings>;
  onUpdateSettings: (settings: Settings) => Promise<void>;
};

const tinyMceFontOptions =
  "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino;Calibri=Carlito; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva;";

export const AppSettings: FC<AppSettingsProps> = ({ settings, onUpdateSettings }) => {
  const { enableAi, enableTechPricing, systemFont } = settings;

  const initialValues = { enableAi, enableTechPricing, systemFont };

  const [form] = Form.useForm();

  const doOnFinish = async (values: any) => {
    await onUpdateSettings(values);
  };

  const selectOpts = tinyMceFontOptions
    .split(";")
    .filter((opt) => !!opt)
    .map((opt) => {
      const [name, value] = opt.split("=");
      return { value, label: name };
    });

  return (
    <div className={containerClassName}>
      <Form form={form} initialValues={initialValues} onFinish={doOnFinish}>
        <Form.Item name="enableAi" label="Enable AI tools globally" valuePropName="checked">
          <Checkbox onChange={() => form.submit()} />
        </Form.Item>
        <Form.Item
          name="enableTechPricing"
          label="Enable technology pricing"
          valuePropName="checked"
        >
          <Checkbox onChange={() => form.submit()} />
        </Form.Item>
        <Form.Item
          getValueFromEvent={(val) => {
            const opts = tinyMceFontOptions.split(";").filter((opt) => !!opt);
            const fullOption = opts.find((opt) => opt.split("=")[1] === val);
            return fullOption;
          }}
          getValueProps={(val) => {
            return { value: val?.split("=")[0] };
          }}
          wrapperCol={{ span: 4 }}
          name="systemFont"
          label="System font"
        >
          <Select options={selectOpts ?? []} onChange={() => form.submit()}></Select>
        </Form.Item>
      </Form>
    </div>
  );
};
